import React, { useEffect, useState } from 'react';
import UserConfigManager from '../components/UserConfigManager';
import { useConfig } from '../contexts/ConfigContext';
import { useAuth, AuthState } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const UserConfigPage: React.FC = () => {
  const { isFirstTimeSetup } = useConfig();
  const { authState } = useAuth();
  const [isReady, setIsReady] = useState(false);
  const navigate = useNavigate();

  // Ensure that auth is fully resolved before proceeding
  useEffect(() => {
    if (authState === AuthState.AUTHENTICATED) {
      setIsReady(true);
    } else if (authState === AuthState.UNAUTHENTICATED) {
      navigate('/login');
    }
  }, [authState, navigate]);

  if (!isReady) {
    return (
      <div className="p-6 flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
        <p className="ml-3 text-gray-600">Preparing configuration page...</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      {isFirstTimeSetup && (
        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded shadow-sm">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-800 font-medium">
                Benvenuto! Configura il tuo primo database per iniziare a usare il sistema.
              </p>
              <p className="text-sm text-blue-700 mt-1">
                Per iniziare, dovrai configurare una cartella Google Drive da utilizzare per l'archiviazione e il recupero dei documenti.
              </p>
            </div>
          </div>
        </div>
      )}
      <UserConfigManager />
    </div>
  );
};

export default UserConfigPage; 